import styled, { css } from 'styled-components';
import { Typography } from '../../../../../global/theme';
import { AlignCenter, FlexBetween } from '../../../../../global/commonStyle';
import { mobile_xl } from '../../../../../global/mediaQueryMixin';

const Main = styled.div`
  padding-block: var(--space-14);
  margin: var(--space-0) auto;
`;
const Header = styled.div`
  padding-block: var(--space-1);
  display: inline-flex;
  align-items: center;
  gap: var(--space-4);
`;
const Title = styled.div`
  ${Typography.body_lg_medium}
  color: var(--text-secondary);
  padding: var(--space-2) var(--space-4);
`;

const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  ${mobile_xl(css`
    padding-top: var(--space-4);
  `)}
`;

const Subheader = styled.div`
  ${FlexBetween}
  gap: var(--space-20);
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-12);
  `)}
`;
const LeftSide = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
`;
const Logo = styled.div`
  width: 42px;
  height: 42px;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
`;
const Text = styled.div`
  ${Typography.heading_lg};
  color: var(--text-primary);
`;

const HeaderText = styled.div`
  ${Typography.body_md};
  color: var(--text-secondary);
`;
const RepositoryData = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  display: flex;
  flex-direction: column;
`;
const Data = styled.div`
  ${FlexBetween}
  gap: var(--space-20);
  border-bottom: 0.5px solid var(--border-primary);
  padding: var(--space-12) var(--space-16);
  :last-child {
    border-bottom: none;
  }
`;
const LeftSideData = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;
const DataTitle = styled.h2`
  ${Typography.body_lg_medium};
  color: var(--text-primary);
  margin: var(--space-0);
`;

const Datatext = styled.p`
  ${Typography.body_md};
  color: var(--text-secondary);
  margin: var(--space-0);
`;
const RemoveButton = styled.div`
  ${Typography.body_md_medium};
  color: var(--brand-primary);
  cursor: pointer;
`;

export {
  Main,
  Header,
  Title,
  BottomContent,
  Subheader,
  LeftSide,
  Logo,
  Content,
  HeaderText,
  Text,
  RepositoryData,
  Data,
  LeftSideData,
  Datatext,
  DataTitle,
  RemoveButton
};
